export default function useJustHireHeaders(): HeadersInit {
  return {
    Authorization: `Bearer ${useRuntimeConfig().public.justHireKey}`,
  };
}